<template>
  <div class="eBikeDetailsDialog-container">
     <!--车辆详情-->
      <div class="top">
        <div class="top-id">{{ eBikeDetails.ebikeId || eBikeId }}</div>
        <div class="top-actions">
          <el-button type="text" @click="showBaseInfo(3)" v-if="showBaseInfoType === 1 && eBikeCode">{{ $t('tabmenu.name68') }}</el-button>
          <el-button type="text" @click="showBaseInfo(2)" v-if="showBaseInfoType === 1">{{ $t('bike.name215') }}</el-button>
          <el-button type="text" @click="showBaseInfo(1)" v-if="showBaseInfoType === 2 || showBaseInfoType === 3">{{ $t('retrievePassword.name1') }}</el-button>
          <el-button type="text" v-if="showBaseInfoType === 1" @click="showBaseInfoDialog">{{ $t('bike.name162') }}</el-button>
        </div>
      </div>

      <div class="title-style"  v-if="showBaseInfoType === 1">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name163') }}</div>
        <el-divider></el-divider>
      </div>
      <el-form class="eBikeDetailsDialog-form" label-position="top" style="width:100%;" v-if="showBaseInfoType === 1">
        <el-row type="flex" class="el-row2">
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name164')">{{ eBikeDetails.ebikeCode }}</el-form-item></el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name65')">{{ eBikeDetails.ebikeId }}</el-form-item></el-col> -->
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name165')">{{ eBikeDetails.mac || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name166')">{{ eBikeDetails.storageTime || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name168')">{{ eBikeDetails.keepliveTime || '-' }}</el-form-item></el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name167')">{{ eBikeDetails.gisTime || '-' }}</el-form-item></el-col> -->
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name169')">{{ eBikeDetails.lng || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name170')">{{ eBikeDetails.lat || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name171')">{{ eBikeDetails.alt || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name508')">
            <!-- 无 keepalive 时 odo 常为 0，与「暂无数据」区分 -->
            <div v-if="hasReportedOdo">{{ formattedOdo }}Km</div>
            <div v-else>-</div>
          </el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name216')">
            <div v-if="eBikeDetails.speed === 0">0km/h</div>
            <div v-else>{{ Number(eBikeDetails.speed / 10).toFixed(1) }}km/h</div>
          </el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name217')">{{ eBikeDetails.soc || '-' }}%</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name218')">
            <div v-if="eBikeDetails.controllerTemp !== null">
              {{ Number(eBikeDetails.controllerTemp) + Number(eBikeDetails.controllerTemperatureShowDeviation) }}℃
            </div>
            <div v-else>
              -℃
            </div>
          </el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name219')">
            <div v-if="eBikeDetails.motorTemp !== null">
              {{ Number(eBikeDetails.motorTemp) + Number(eBikeDetails.motorTemperatureShowDeviation) }}℃
            </div>
            <div v-else>
              -℃
            </div>
          </el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name220')">
            <div v-if="eBikeDetails.batteryTemp !== null">
              {{ Number(eBikeDetails.batteryTemp) + Number(eBikeDetails.batteryTemperatureShowDeviation) }}℃
            </div>
            <div v-else>
              -℃
            </div>
          </el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name222')">{{ Number(eBikeDetails.batteryCurrent / 3).toFixed(1) || '-' }}A</el-form-item></el-col> -->
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name221')">{{ Number(eBikeDetails.batteryVoltage / 10).toFixed(1) || '-' }}V</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name223')">{{ lockStatusText }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name226')">{{ eBikeDetails.status === 0 ? $t('bike.name227') : $t('bike.name228') }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('manage.name78')">{{ eBikeDetails.remark || '-' }}</el-form-item></el-col>
        </el-row>
        <!-- VIP 日期放在基本信息最后（备注之后）；后面的报警列表不属于基本信息 -->
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name611')">{{ formatVipDate(eBikeDetails.vipStartDate) }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name612')">{{ formatVipDate(eBikeDetails.vipEndDate) }}</el-form-item></el-col>
        </el-row>
        <!-- <el-row class="el-row2">
          <el-col :span="24"><el-form-item :label="$t('manage.name78')">{{ eBikeDetails.remark || '-' }}</el-form-item></el-col>
        </el-row> -->
      </el-form>
      <div class="title-style"  v-if="showBaseInfoType === 2">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name229') }}</div>
        <el-divider></el-divider>
      </div>
      <el-form class="eBikeDetailsDialog-form" label-position="top" style="width:100%;" v-if="showBaseInfoType === 2">
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name295')">{{ eBikeDetails.ebikeCode || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name313')">{{ eBikeDetails.manufactureDate || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name2')">{{ eBikeDetails.ebikeModelId || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name48')">{{ eBikeDetails.ebikeModelName || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name183')">{{ eBikeDetails.ebikeFrameColor || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name235')">{{ eBikeDetails.iotVersionNo || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name31')">{{ eBikeDetails.controllerVersion || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name241')">{{ eBikeDetails.batteryVersion }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name245')">{{ eBikeDetails.motorVersion || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name250')">{{ eBikeDetails.meterVersion || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name238')">{{ eBikeDetails.controllerNo || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name246')">{{ eBikeDetails.motorNo || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name249')">{{ eBikeDetails.meterNo || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name242')"> {{ eBikeDetails.batteryNo || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name319')">{{ eBikeDetails.ebikeCnBrand || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name320')">{{ eBikeDetails.ebikeEnBrand || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name321')">{{ eBikeDetails.manufacturingPlantAddress || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name330')">{{ eBikeDetails.batteryManufactureEnterpriseName || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name338')">{{ eBikeDetails.motorManufactureEnterprise || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name344')">{{ eBikeDetails.controllerManufactureEnterprise || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name317')">{{ eBikeDetails.ebikeManufacturer || '-' }}</el-form-item></el-col>
        </el-row>

         <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name356')">{{ eBikeDetails.iotManufactureEnterprise || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name366')">{{ eBikeDetails.productModel || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name372')"><el-image style="width: 100px; height: 100px" v-if="eBikeDetails.certificateConformityUrl" :src="eBikeDetails.certificateConformityUrl" :preview-src-list="[eBikeDetails.certificateConformityUrl]"></el-image></el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name527')">{{ eBikeDetails.chargerModel  || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name528')">{{ eBikeDetails.chargerStandards || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name586')">{{ eBikeDetails.chargerManufactureEnterpriseName || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name587')">{{ eBikeDetails.chargerNo || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name373')">
             <div v-if="eBikeDetails.imageList" class="img-list">
              <div v-for="(item, index) in eBikeDetails.imageList" :key="index">
              <el-image style="width: 100px; height: 100px; margin-right: 15px" :src="item" :initial-index="index" :preview-src-list="eBikeDetails.imageList"></el-image>
            </div>
            </div>
          </el-form-item></el-col>
        </el-row>
        <!-- <el-row class="el-row2">
          <el-form-item :label="$t('bike.name373')" >
            <div v-if="eBikeDetails.imageList" class="img-list">
              <div v-for="(item, index) in eBikeDetails.imageList" :key="index">
              <el-image style="width: 100px; height: 100px; margin-right: 15px" :src="item" :initial-index="index" :preview-src-list="eBikeDetails.imageList"></el-image>
            </div>
            </div>
          </el-form-item>
        </el-row> -->
      </el-form>
      <div class="title-style"  v-if="showBaseInfoType === 2">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name370') }}</div>
        <el-divider></el-divider>
      </div>
      <el-form class="eBikeDetailsDialog-form" label-position="top" style="width:100%;" v-if="showBaseInfoType === 2">
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name314')">{{ eBikeDetails.cccCode || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name315')">{{ (eBikeDetails.certificateExpireDate || '').toString().split(/[\sT]/)[0] || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name316')">{{ eBikeDetails.productCertificateNumber || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name350')">{{ eBikeDetails.executiveStandardNumber || '-' }}</el-form-item></el-col>
        </el-row>
      </el-form>
      <div class="title-style"  v-if="showBaseInfoType === 2">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name371') }}</div>
        <el-divider></el-divider>
      </div>
      <el-form class="eBikeDetailsDialog-form" label-position="top" style="width:100%;" v-if="showBaseInfoType === 2">
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name236')">{{ eBikeDetails.iotTemperatureShowDeviation || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name237')">{{ eBikeDetails.iotTemperatureShowWarnDefaultValue || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name239')">{{ eBikeDetails.controllerTemperatureShowDeviation }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name240')">{{ eBikeDetails.controllerTemperatureShowWarnDefaultValue || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name243')">{{ eBikeDetails.batteryTemperatureShowDeviation || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name244')">{{ eBikeDetails.batteryTemperatureShowWarnDefaultValue || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name247')">{{ eBikeDetails.motorTemperatureShowDeviation || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name248')">{{ eBikeDetails.motorTemperatureShowWarnDefaultValue || '-'}}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name322')">{{ eBikeDetails.lengthValue || '-' }} * {{ eBikeDetails.widthValue || '-' }} * {{ eBikeDetails.heightValue || '-'  }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name323')">{{ eBikeDetails.ebikeWeight || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name324')">{{ eBikeDetails.maxDesignSpeed || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name325')">{{ eBikeDetails.nameplateFixedPosition || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name326')">{{ eBikeDetails.ebikeFrameCodePosition || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name327')">{{ eBikeDetails.enduranceMileage || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name328')">{{ eBikeDetails.ebikeOutlinePicName || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name328')">{{ eBikeDetails.ebikeOutlinePicName || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name329')">{{ eBikeDetails.batteryType || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name331')">{{ eBikeDetails.batteryCapacity || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name332')">{{ eBikeDetails.batteryModel || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name333')">{{ eBikeDetails.batteryWeight || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name334')">{{ eBikeDetails.batteryLength || '-' }} * {{ eBikeDetails.batteryWidth || '-' }} * {{ eBikeDetails.batteryHeight || '-'  }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name335')">{{ eBikeDetails.beforeAfterWheelDistance || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name336')">{{ eBikeDetails.driveType  || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name337')">{{ eBikeDetails.hundredKmPowerConsumption || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name339')">{{ eBikeDetails.electricalMachineryModel || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name340')">{{ eBikeDetails.motorType || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name341')">{{ eBikeDetails.motorRatedSpeed || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name342')">{{ eBikeDetails.motorRatedVoltage || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name343')">{{ eBikeDetails.motorRatedOutputPower || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name345')">{{ eBikeDetails.controllerModel || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name346')">{{ eBikeDetails.controllerUndervoltageProtectionValue || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name347')">{{ eBikeDetails.controllerOvercurrentProtectionValue || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name348')">{{ eBikeDetails.frontTireSpecifications || '-' }}</el-form-item></el-col>
        </el-row>
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name349')">{{ eBikeDetails.rearTireSpecifications || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name351')">{{ eBikeDetails.deadweightCapacity || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name354')">{{ eBikeDetails.brakeType || '-' }}</el-form-item></el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name352')">{{ eBikeDetails.batteryNominalVoltage || '-' }}</el-form-item></el-col> -->
        </el-row>
        <!-- <el-row class="el-row2"> -->
          <!-- <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name353')">{{ eBikeDetails.motorNominalPower || '-' }}</el-form-item></el-col> -->
        <!-- </el-row> -->
        <el-row type="flex" class="el-row2">
          <el-col :xs="24" :sm="12" :md="8"><el-form-item :label="$t('bike.name355')">{{ eBikeDetails.transmissionSpecifications || '-' }}</el-form-item></el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('bike.name376')">{{ eBikeDetails.iotVersionNo || '-' }}</el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('bike.name377')">{{ eBikeDetails.iotHwVersionNo || '-' }}</el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div class="title-style"  v-if="showBaseInfoType === 3">
        <el-divider></el-divider>
        <div class="title">{{ $t('tabmenu.name68') }}</div>
        <el-divider></el-divider>
      </div>
      <div v-if="showBaseInfoType === 3">
        <el-table :data="maintenanceRecordList" :span-method="objectSpanMethod" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
          <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name450')" prop="id" sortable width="200"> </el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable></el-table-column>
      <el-table-column :label="$t('bike.name453')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name454')" prop="maintainTypeName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name455')" prop="oldPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name456')" prop="newPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name457')" prop="filePathList" sortable>
        <template slot-scope="scope" v-if="scope.row.filePathList.length > 0">
          <el-image style="width: 50px; height: 50px" :src="scope.row.filePathList[0]" :preview-src-list="scope.row.filePathList"></el-image>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      background
      @size-change="handleMaintenanceSizeChange"
      @current-change="handleMaintenanceCurrentChange"
      :current-page="maintenanceRecord.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="maintenanceRecord.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="maintenanceRecordTotal"
    >
    </el-pagination> -->
      </div>
      <div class="title-style" v-if="showBaseInfoType === 1">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name230') }}</div>
        <el-divider></el-divider>
      </div>
      <el-table :data="alarmMessageList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-if="showBaseInfoType === 1">
      <el-table-column :label="$t('bike.name231')" prop="changeTime">
        <template slot-scope="scope">
          {{ scope.row.changeTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name232')" prop="state" >
        <template slot-scope="scope">
          <div>{{ scope.row.state === 1 ? $t('bike.name233') : $t('bike.name234') }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      v-if="showBaseInfoType === 1"
      background
      @size-change="handleAlarmSizeChange"
      @current-change="handleAlarmCurrentChange"
      :current-page="pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="alarmTotal"
    >
    </el-pagination>
      <!-- <template #footer> -->
        <!-- <el-button type="primary" @click="close">确定</el-button> -->
        <!-- <el-button @click="close">{{ $t('public.name14') }}</el-button> -->
      <!-- </span> -->
      <!--修改车辆基本信息-->
      <AppDialog size="sm" :title="$t('bike.name162')" :visible.sync="eBikeBaseInfoDialog" v-if="eBikeBaseInfoDialog" :before-close="closeBaseInfoDialog">
        <el-form :label-width="formLabelWidth()" style="width:100%;" :model="eBikeBaseInfo">
          <!-- <el-form-item label="web配置：">
            <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="eBikeBaseInfo.webConfiguration">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('manage.name78')">
            <el-input
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            :placeholder="$t('public.name5')"
            v-model="eBikeBaseInfo.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handlerDelBike" :loading="loading3" v-if="false">{{ $t('bike.name253') }}</el-button>
        <el-button type="primary" @click="handlerModify" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBaseInfoDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import {
  bindModel,
  cancelBindModel,
  findEbikeDetail,
  findEbikeDetail1,
  getEbikePosture,
  sendTransportInfo,
  tenantBindEbike,
  importEbikeVin,
  importTenantBindEbike,
  importEbikeIdMacNoTenantId,
  modifyEbikeBaseInfo,
  findOtaFirmwarePage,
  findEbikeModelPage,
  otaFirmwareInfoList2,
  otaFirmwareInfoList3,
  sendUpgradeInfo,
  findIotStatusInfo,
  findIotSubscribeTopic,
  findIotCmdLog,
  exportEbike,
  removeIotEbike,
  addEbike,
  importEbikeBaseInfo,
  importCertificate,
  importEbikeModelCertificateConformity,
  downloadTempFile,
  queryWebMaintainRecordListByEbikeCode
} from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
import { scheduleDialogScrollReset } from '@/utils/dialogScroll'
import { formatVipDate } from '@/utils/formatVipDate'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    lockStatusText () {
      const s = this.eBikeDetails.lockStatus
      if (s === 0) return this.$t('bike.name224')
      if (s === 4) return this.$t('bike.name601')
      return this.$t('bike.name225')
    },
    // 有 keepalive 上报才展示总里程，避免默认 odo=0 误导
    hasReportedOdo () {
      const { keepliveTime, odo } = this.eBikeDetails
      if (!keepliveTime) return false
      if (odo == null || odo === '') return false
      return true
    },
    formattedOdo () {
      return (Number(this.eBikeDetails.odo) / 10).toFixed(1)
    },
    typeAllOptions () {
      return [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ]
    },
    statusOptions () {
      return [
        {
          value: '1',
          label: this.$t('bike.name45')
        },
        {
          value: '0',
          label: this.$t('bike.name113')
        }
      ]
    }
  },
  props: {
    eBikeId: {
      type: String,
      default: () => ''
    },
    eBikeCode: {
      type: String,
      default: () => ''
    },
    type: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      showBaseInfoType: 1,
      shouldResetDialogScroll: true,
      eBikeDetails: {},
      certificateDetails: {},
      tenantIds2: [],
      productUploadDialog: false,
      bikeUploadDialog: false,
      bikeFactoryUploadDialog: false,
      tenantIds: [],
      searchTime: null,
      iotDetailsDialog: false,
      eBikeBaseInfoDialog: false,
      iotDialog: false,
      eBikeBaseInfo: {
        ebikeId: '',
        remark: ''
      },
      typeOptions: [],
      loading1: false,
      loading2: false,
      loading3: false,
      exportLoading: false,
      pageNumber: 1,
      pageSize: 10,
      alarmTotal: 0,
      alarmMessageList: [],
      subscribeList: [],
      importIotNumDialog: false,
      assignOperatorsDialog: false,
      versionConfigurationDialog: false,
      fiveWayCodeUploadDialog: false,
      eBikeDetailsDialog: false,
      iotDetails: {},
      addIotNumDialog: false,
      vehicleModelBindingDialog: false,
      tenantOptions: [],
      manufacturerOptions: [],
      modelOptions: [],
      bindingForm: {
        ebikeModelId: '',
        ebikeIdList: []
        // ebikeVinNo: ''
      },
      fileList: [],
      belong: {
        tenantId: []
      },
      belongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      importBelong: {
        tenantId: []
      },
      importBelongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      bindingFormRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name468'),
            trigger: 'blur'
          }
        ]
      },
      assignOperatorsForm: {
        tenantId: ''
      },
      assignOperatorsFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name469'),
            trigger: 'blur'
          }
        ]
      },
      versionConfigurationForm: {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      },
      versionConfigurationFormRules: {
        otaFirewareInfoId: [
          {
            required: true,
            message: this.$t('bike.name470'),
            trigger: 'blur'
          }
        ],
        hardwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      },
      queryInfo: {
        status: '',
        ebikeId: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: []
      },
      tableLoading: false,
      loading: false,
      selectionList: [],
      options: [],
      ridelist: [
        {
          bikeCode: '',
          email: '',
          remark: '',
          ebikeId: '',
          type: '',
          bikeMac: '',
          status: '',
          isTransport: '',
          controllerEdition: '',
          meterEdition: '',
          iotEdition: '',
          ebikeModelId: '',
          ebikeModelName: '',
          motorNo: '',
          ebikeVinNo: ''
        }
      ],
      isTransportlist: [],

      // 详情提示框
      ebikeId: '',
      dialogBikeInfoVisible: false,
      IOTebikeId: '',
      dialogIoTisible: false,
      // 延迟
      // 车型绑定
      modelist: [],
      modelVisible: false,
      modelFrom: {
        ebikeModelId: '',
        ebikeId: [],
        ebikeVinNo: ''
      },
      modelFromRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name472'),
            trigger: 'blur'
          }
        ]
      },
      // OTA升级
      selectlist: [],
      disposeOTAVisible: false,
      disposeOTAFrom: {
        ebikeId: [],
        hardwareType: '',
        versionNumber: ''
      },
      versionNumberOptions: [],
      TypefirmwareList: [],
      fiveWayCodeFile: null,
      ImportbikeVisible: false,
      buttonPerms: '',
      tenantAllOptions: [],
      iotLogInfo: '',
      timer: null,
      addBikeDialog: false,
      addEBikeInfo: {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      },
      maintenanceRecordList: [],
      maintenanceRecordTotal: 0,
      maintenanceRecord: {
        pageNumber: 1,
        pageSize: 10
      },
      spanArr: [],
      pos: 0,
      uploadTenantId: '',
      addBikeFormRules: {
        // tenantId: [
        //   {
        //     required: true,
        //     message: this.$t('public.name45'),
        //     trigger: 'blur'
        //   }
        // ],
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        mac: [
          {
            required: true,
            message: this.$t('bike.name479'),
            trigger: 'blur'
          }
        ],
        testStatus: [
          {
            required: true,
            message: this.$t('public.name1'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    AppDialog
  },
  created() {
  },
  mounted() {
    this.eBikeBaseInfo.ebikeId = this.eBikeId
    this.queryAlarmList()
    this.refreshBikeDetail()
    this.timer = setInterval(this.refreshBikeDetail, 5000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    formatVipDate,
    resetQuery() {
      this.queryInfo = {
        status: '',
        ebikeId: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: []
      }
      this.tenantIds = []
    },
    /** 详情内 CRUD 后通知父页刷新列表（弹窗本身不拉整车列表） */
    notifyParentListChanged() {
      this.$emit('list-changed')
    },
    exportEbikeData() {
      this.exportLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      // console.log('queryInfo=====', this.queryInfo)
      // this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      // this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      // this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      exportEbike(this.queryInfo).then(res => {
        this.exportLoading = false
        downloadExcel(res, this.$t('bike.name229'))
      }).catch(() => {
        this.exportLoading = false
      })
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showImportIotNum() {
      this.importIotNumDialog = true
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    showAssignOperatorsDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.assignOperatorsDialog = true
    },
    showVersionConfigurationDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.versionConfigurationDialog = true
    },
    showFiveCodeDialog() {
      this.fiveWayCodeUploadDialog = true
    },
    // showDetailsDialog(row) {
    //   this.eBikeBaseInfo.ebikeId = row.ebikeId
    //   this.getBikeDetails()
    //   this.showBaseInfoType = 1
    //   this.eBikeDetailsDialog = true
    // },
    getBikeDetails() {
      this.queryAlarmList()
      this.refreshBikeDetail()
    },
    refreshBikeDetail() {
      const detailPromise = this.type === 4
        ? findEbikeDetail1({ ebikeCode: this.eBikeCode })
        : findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId })
      detailPromise.then(res => {
        if (res.code === 200) {
          this.eBikeDetails = res.data.iotEbike
        }
      }).then(() => {
        this.ensureDialogScrollTop()
      })
    },
    ensureDialogScrollTop() {
      if (!this.shouldResetDialogScroll) return
      this.shouldResetDialogScroll = false
      scheduleDialogScrollReset(this.$el)
    },
    showBaseInfo(type) {
      this.showBaseInfoType = type
      if (type === 3) {
        this.getMaintainRecordList(this.eBikeCode)
      }
    },
    showBaseInfoDialog() {
      this.eBikeBaseInfoDialog = true
    },
    handlerDelBike() {
      this.$confirm(this.$t('bike.name381'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeIotEbike({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
            if (res.code === 200) {
              this.closeBaseInfoDialog()
              this.eBikeDetailsDialog = false
              clearInterval(this.timer)
              this.timer = null
              this.notifyParentListChanged()
              this.$message({ type: 'success', message: this.$t('public.name30') })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handlerModify() {
      this.loading3 = true
      modifyEbikeBaseInfo(this.eBikeBaseInfo)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
              if (res.code === 200) {
                this.eBikeDetails = res.data.iotEbike
              }
            })
            this.closeBaseInfoDialog()
          }
        })
        .catch(() => {
          this.loading3 = false
        })
    },
    closeBaseInfoDialog() {
      this.eBikeBaseInfoDialog = false
      this.eBikeBaseInfo.remark = ''
      // this.pageSize = 10
      // this.pageNumber = 1
      // this.alarmTotal = 0
      // this.alarmMessageList = []
    },
    showIotDetailsDialog(row) {
      this.iotDetailsDialog = true
      this.ebikeId = row.ebikeId
      this.getIOTDetails()
      this.timer = setInterval(this.getIOTDetails, 10000)
    },

    getIOTDetails() {
      findIotStatusInfo({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.iotStatusInfo.length > 0) {
              this.iotDetails = res.data.iotStatusInfo[0]
            }
          }
        })
        .catch(() => {
        })
      findIotSubscribeTopic({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.subscribeList = res.data.topic
          }
        })
        .catch(() => {
          this.subscribeList = []
        })
    },
    submitVersionConfiguration() {
      this.$refs.versionConfigurationFormRef.validate((valid) => {
        if (valid) {
          this.loading2 = true
          this.versionConfigurationForm.ebikeIdList = []
          this.selectionList.map((item, index) => {
            this.versionConfigurationForm.ebikeIdList.push(item.ebikeId)
          })
          sendUpgradeInfo(this.versionConfigurationForm)
            .then((res) => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.notifyParentListChanged()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitAssignOperators() {
      this.$refs.assignOperatorsFormRef.validate(valid => {
        if (valid) {
          this.loading2 = true
          const ebikeIdList = []
          this.selectionList.map((item, index) => {
            ebikeIdList.push(item.ebikeId)
          })
          tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.assignOperatorsForm.tenantId })
            .then(res => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.notifyParentListChanged()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.close()
                    this.notifyParentListChanged()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    changeTransportMode() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      if (this.selectionList.length > 1) {
        this.$message.warning(this.$t('bike.name382'))
        return
      }
      const ebikeIdList = []
      this.selectionList.map((item, index) => {
        ebikeIdList.push(item.ebikeId)
      })
      this.$confirm(this.$t('bike.name383'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.loading1 = true
          sendTransportInfo({ ebikeId: ebikeIdList[0] })
            .then(res => {
              this.loading1 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.notifyParentListChanged()
              }
            })
            .catch(() => {
              this.loading1 = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    close() {
      this.shouldResetDialogScroll = true
      this.vehicleModelBindingDialog = false
      this.assignOperatorsDialog = false
      this.assignOperatorsForm = {
        tenantId: ''
      }
      this.versionConfigurationDialog = false
      this.fiveWayCodeUploadDialog = false
      this.eBikeDetailsDialog = false
      this.bindingForm = {
        ebikeModelId: '',
        ebikeIdList: []
      }
      this.importIotNumDialog = false
      this.addIotNumDialog = false
      this.belong = {
        tenantId: ''
      }
      this.importBelong = {
        tenantId: ''
      }
      this.versionConfigurationForm = {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      }
      this.versionConfigurationDialog = false
      this.searchTime = null
      this.iotLogInfo = ''
      this.iotDetailsDialog = false
      this.iotDialog = false
      clearInterval(this.timer)
      this.timer = null
    },
    async queryAlarmList () {
      if (!this.eBikeBaseInfo.ebikeId) {
        this.alarmMessageList = []
        this.alarmTotal = 0
        return
      }
      try {
        const res = await getEbikePosture({
          ebikeId: this.eBikeBaseInfo.ebikeId,
          pageSize: this.pageSize,
          pageNumber: this.pageNumber
        })
        if (res && res.code === 200 && res.data && res.data.ebikePosturePage) {
          this.alarmMessageList = res.data.ebikePosturePage.records || []
          this.alarmTotal = res.data.ebikePosturePage.total || 0
        } else {
          this.alarmMessageList = []
          this.alarmTotal = 0
        }
      } catch (e) {
        this.alarmMessageList = []
        this.alarmTotal = 0
      }
    },
    showModeBindDialog() {
      if (this.selectionList.length > 0) {
        this.selectionList.map((item, index) => {
          this.bindingForm.ebikeIdList.push(item.ebikeId)
        })
        this.vehicleModelBindingDialog = true
      } else {
        this.$message.warning(this.$t('bike.name380'))
      }
    },
    bindingVehicleMode() {
      this.$refs.bindingFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          bindModel(this.bindingForm).then(res => {
            this.loading = false

            console.log('===', res.code)
            if (res.code === 200) {
              this.notifyParentListChanged()
              this.$refs.table.clearSelection()
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
          this.close()
        } else {
          return false
        }
      })
    },
    handleCancelBindModel(row) {
      this.$confirm(this.$t('bike.name384'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          cancelBindModel({ ebikeIdList: [row.ebikeId] }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('bike.name385')
              })
              this.refreshBikeDetail()
              this.notifyParentListChanged()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('bike.name386')
          })
        })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    loadOptions(node, resolve) {
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    loadOptions1() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.manufacturerOptions = options
            this.uploadTenantId = this.manufacturerOptions[0].value
          } else {
            this.manufacturerOptions = []
          }
        })
        .catch(() => {})
    },
    versionLoadOptions(node, resolve) {
      console.log('====', node)
      let data = {
        pageNumber: 1,
        pageSize: 500
      }
      if (node.level === 1) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          tenantId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          parentId: node.value
        }
      }
      findOtaFirmwarePage(data).then((res) => {
        var options = []
        if (node.level === 0) {
          options = res.data.page.records.map((item) => ({ value: item.tenantId, label: item.tenantName, leaf: node.level >= 2 }))
        }
        if (node.level === 1) {
          options = res.data.page.records.map((item) => ({ value: item.firmwareType, label: ['IOT', this.$t('bike.name14'), this.$t('bike.name413')][item.firmwareType], leaf: node.level >= 2 }))
        }
        resolve(options)
      }).catch(() => {})
    },
    handleVersionChange(value) {},
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.belong.tenantId = value[value.length - 1]
      this.importBelong.tenantId = value[value.length - 1]
      // this.addEBikeInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    handleChange1(value) {
      // 导出筛选：仅更新 permTenantList，不触发父页列表刷新
      this.queryInfo.permTenantList = []
      if (value.length > 0) {
        value.map((item) => {
          this.queryInfo.permTenantList.push(item[item.length - 1])
        })
      }
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          loading.close()
          downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
          this.notifyParentListChanged()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleAlarmSizeChange(newSize) {
      this.pageSize = newSize
      this.queryAlarmList()
    },
    // 告警子表翻页：服务端分页
    handleAlarmCurrentChange(newPage) {
      this.pageNumber = newPage
      this.queryAlarmList()
    },

    // 导入五通码
    Importbike() {
      this.ImportbikeVisible = true
    },
    ImportbikeDialogBefore() {
      this.ImportbikeVisible = false
    },
    uploadFile(file) {
      this.fiveWayCodeFile = file
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
      // let obj = new Object()
      // obj.name = e.target.files[0].name
      // obj.url = e.target.files[0].name
      // this.fileList = [{}]
      // console.log('e===', e.target.files[0])
    },
    uploadSectionFile1() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeVin(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name388'))
          } else {
            this.$confirm(this.$t('bike.name389') + '?', this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name390'), 'xlsx', true)
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.notifyParentListChanged()
          this.fiveWayCodeUploadDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    uploadSectionFile2() {
      if (this.fiveWayCodeFile === null) {
        this.$message.error(this.$t('public.name38'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.importBelong.tenantId)
      this.loading2 = true
      importTenantBindEbike(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            // console.log('res====2', res)
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389') + '?', this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.$refs.table.clearSelection()
          this.notifyParentListChanged()
          this.importIotNumDialog = false
          this.importBelong.tenantId = ''
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showIOTDialog() {
      this.iotDialog = true
    },
    uploadSectionFile3() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          this.loading2 = false
          // console.log('res====1', res)
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389') + '?', this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.notifyParentListChanged()
          this.iotDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },

    onUploadSuccess() {
      this.$message.success(this.$t('public.name64'))
      this.$refs.uploadss.clearFiles()
      this.ImportbikeVisible = false
      this.getBikes()
    },
    beforebikeupload(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (size > 50) {
        this.$message.warning(this.$t('public.name65'))
        return false
      }
      if (extension !== 'xlsx') {
        this.$message.warning(this.$t('public.name66'))
        return false
      }
    },
    getOtaFirmwareInfoLlist2() {
      const data = {
        tenantId: this.userinfo.tenantId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.userinfo.tenantId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionNumberOptions = res.data
        })
        .catch(() => {
          this.versionNumberOptions = []
        })
    },
    getIotLog() {
      if (this.searchTime) {
        this.loading = true
        // 车辆开发人员查看原始运行日志：picker 选的墙钟直接当 UTC 检索条件，不做任何时区换算
        const [startTime, endTime] = this.searchTime
        findIotCmdLog({ startTime, endTime, ebikeId: this.ebikeId, wrap: '</br>' }).then((res) => {
          if (res.data.iotLogInfo) {
            this.iotLogInfo = res.data.iotLogInfo
          } else {
            this.iotLogInfo = this.$t('public.name39')
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    showAddBikeDialog() {
      this.addBikeDialog = true
    },
    closeAddBikeDialog() {
      this.addBikeDialog = false
      this.addEBikeInfo = {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      }
    },
    handlerAddBike() {
      this.$refs.addBikeRef.validate(valid => {
        if (valid) {
          this.loading3 = true
          // if (Array.isArray(this.addEBikeInfo.tenantId)) {
          //   this.addEBikeInfo.tenantId = this.addEBikeInfo.tenantId[0]
          // }
          addEbike(this.addEBikeInfo).then(res => {
            this.loading3 = false
            if (res.code === 200) {
              this.notifyParentListChanged()
              this.closeAddBikeDialog()
            }
          }).catch(() => {
            this.loading3 = false
          })
        } else {
          return false
        }
      })
    },
    importProductDialog() {
      this.productUploadDialog = true
    },
    closeProductUpload() {
      this.productUploadDialog = false
      this.tenantIds2 = []
    },
    handleChange2(value) {
      // 处理选项变化
      this.uploadTenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    uploadSectionFile4() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('tenantId', this.uploadTenantId)
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importCertificate(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name393'))
          } else {
            this.$confirm(this.$t('bike.name394') + '?', this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name395'), 'xlsx', true)
            }).catch(() => {})
          }
          this.notifyParentListChanged()
          this.productUploadDialog = false
          this.fiveWayCodeFile = null
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    importBikeInfoDialog() {
      this.bikeUploadDialog = true
    },
    importBikeFactoryDialog() {
      this.bikeFactoryUploadDialog = true
    },
    closeBikeUpload() {
      this.bikeUploadDialog = false
      this.bikeFactoryUploadDialog = false
      this.tenantIds2 = []
    },
    uploadSectionFile5() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeBaseInfo(formData)
        .then(res => {
          this.loading3 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name396'))
          } else {
            this.$confirm(this.$t('bike.name397') + '?', this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name398'), 'xlsx', true)
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.notifyParentListChanged()
          this.bikeUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading3 = false
        })
    },
    uploadSectionFile6() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeModelCertificateConformity(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name399') + '?', this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name400'), 'xlsx', true)
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name401'))
            }
          }
          this.$refs.table.clearSelection()
          this.notifyParentListChanged()
          this.bikeFactoryUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    getMaintainRecordList(ebikeCode) {
      this.tableLoading = true
      queryWebMaintainRecordListByEbikeCode({ ebikeCode: ebikeCode })
        .then((res) => {
          if (res.code === 200) {
            this.maintenanceRecordList = res.data
            this.pos = 0
            this.spanArr = []
            this.getSpanArr(this.maintenanceRecordList)
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 7) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    }
    // handleMaintenanceSizeChange(newSize) {
    //   this.maintenanceRecord.pageSize = newSize
    //   this.getMaintainRecordList()
    // },
    // handleMaintenanceChange(newPage) {
    //   this.maintenanceRecord.pageNumber = newPage
    //   this.getMaintainRecordList()
    // }
  }
}
</script>
<style lang="scss">
.eBikeDetailsDialog-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  .eBikeDetailsDialog-form.el-form--label-top {
    width: 100%;
    max-width: 100%;
    min-width: 0;

    .el-form-item {
      display: block;
      margin-bottom: 14px;

      .el-form-item__label {
        display: block;
        float: none;
        text-align: left;
        padding: 0 0 6px;
        line-height: 1.4 !important;
        white-space: normal;
        word-break: break-word;
        width: 100% !important;
        color: #909399;
      }

      .el-form-item__content {
        display: block;
        float: none;
        line-height: 1.5 !important;
        margin-left: 0 !important;
        width: 100%;
        max-width: 100%;
        word-break: break-word;
        color: #303133;
      }
    }
  }

  .el-row2 {
    flex-wrap: wrap;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;
    max-width: 100%;

    > .el-col {
      float: none;
      min-width: 0;
      box-sizing: border-box;
      padding-right: 16px;
    }

    .el-form-item {
      margin-bottom: 14px;
    }
  }

  .el-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px 12px;
    max-width: 100%;
    white-space: normal;

    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump,
    .btn-prev,
    .btn-next,
    .el-pager {
      margin: 0;
    }
  }

  .el-table {
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
.eBikeDetailsDialog-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  .top{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px 12px;

    .top-id {
      flex: 1 1 100%;
      min-width: 0;
      word-break: break-all;
      font-weight: 500;
      font-size: 15px;
    }

    .top-actions {
      flex: 1 1 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 4px 16px;
      min-width: 0;

      .el-button--text {
        white-space: normal;
        height: auto;
        line-height: 1.4;
        padding: 4px 0;
        margin: 0;
      }
    }
  }

  .add-user{
    display: flex;
    flex-direction: row;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      flex-shrink: 0;
      padding: 0 12px;
      text-align: center;
      white-space: nowrap;
    }
    .el-divider {
      flex: 1;
      margin: 12px 0;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }
  .img-list{
    display: flex;
    flex-direction: row;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
